import { BaseRecord, useNotification } from "@refinedev/core";
import { useCallback, useEffect, useState } from "react";
import { getErrorMessage } from "../../api/error";
import { httpClient, ROOT_URL } from "../../App";
import { ICompany } from "../../interfaces/companies";

interface IDataEditProviderWallet {
  currencyData: any;
  networkData: any;
  companyData: ICompany;
}

export const useProviderWallet = (fieldData?: BaseRecord) => {
  const [data, setData] = useState<IDataEditProviderWallet>();
  const [isLoading, setIsLoading] = useState(false);
  const { open: openNotification } = useNotification();

  const fetch = useCallback(async () => {
    if (
      !Number.isInteger(fieldData?.assetConfigGroupId) ||
      !Number.isInteger(fieldData?.networkId) ||
      !Number.isInteger(fieldData?.companyId)
    ) {
      return;
    }
    setIsLoading(true);
    try {
      const currencyResult = await httpClient.get(
        `${ROOT_URL}/api/v1/asset-config-groups/crypto`
      );

      const networkResult = await httpClient.get(`${ROOT_URL}/api/v1/networks`);

      const companyResult = await httpClient.get(
        `${ROOT_URL}/api/v1/companies/${fieldData?.companyId}`
      );

      if (
        currencyResult.status === 200 &&
        networkResult.status === 200 &&
        companyResult.status === 200
      ) {
        const dataResult = {
          currencyData: currencyResult?.data?.data,
          networkData: networkResult.data,
          companyData: companyResult.data,
        };
        setData(dataResult);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      setData(undefined);
      if (openNotification) {
        openNotification({
          key: "edit_failure",
          message: `Error loading provider wallet #${fieldData?.id}`,
          description: message || "Something went wrong",
          type: "error",
        });
      }
    }
    setIsLoading(false);
  }, [
    fieldData?.assetConfigGroupId,
    fieldData?.networkId,
    fieldData?.companyId,
    fieldData?.id,
    openNotification,
  ]);

  const clearData = useCallback(() => {
    setData(undefined);
  }, []);

  useEffect(() => {
    if (fieldData === undefined) {
      clearData();
    } else {
      fetch();
    }
  }, [fieldData, clearData, fetch]);

  return {
    data,
    fetch,
    isLoading,
    clearData,
  };
};
